<template>
  <div class="about">
    <mainPage :menus="enumeration.aboutMenu" 
              :propActiveMenu="contentType"
              @handleMainMenu="handleMainMenu"
              pageTitle="关于我们">
      <el-card>
        <div class="detail_wrap" v-loading="loadState">
          <div v-if="!formData.content" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
          <div class="article-content"
               v-html="formData.content">
          </div>
        </div>
      </el-card>
    </mainPage>
  </div>
</template>

<script>
import mainPage from './layout/main-page'
import {enumeration} from '@/assets/js/enumeration.js'

export default {
  name: 'about',
  components: { 
    mainPage
  },
  data () {
    return {
      enumeration,
      contentType: 'land_sea_new_channel',
      formData: {},
      loadState: false
    }
  },
  filters: {
  },
  computed: {
    localeLang: {
      get () { return this.$store.state.common.localeLang },
    }
  },
  watch: {
  },
  mounted () {
    this.handleMainMenu()
  },
  methods: {
    handleMainMenu (val) {
      if (val) this.contentType = val.value
      this.loadState = true
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/websiteContent/getByType'),
        method: 'get',
        params: {
          contentType: this.contentType
        }
      }).then((res) => {
        if (res.data.code === 'C0000') {
          let object = res.data.result || {}
          this.formData = object
        }
      }).finally(() => {
        this.loadState = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.about{
  .detail_wrap{
    padding: 20px;
  }
  .title{
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin: 20px 0;
  }
  .content{
    line-height: 28px;
    color: #505050;
    img{
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about.vue